import './cookies'
import './go-up';
import './main-nav';
import serviceModal from './modules/service-modal';

import AOS from 'aos';
AOS.init();

const newsletterSubmit = (e) => {
  e.preventDefault();
  const formData = new FormData();
  formData.append('ne', 'test@es.pl');
  formData.append('ny', true);
  fetch('/?na=ajaxsub', {
    method: 'post',
    body: formData
  })
    .then(res => {
      if(res.ok) {
        res.text().then(message => {
          // document.querySelector('.newsletter-sign-up').innerHTML = message;
          document.querySelector('.newsletter-sign-up-after h3').innerHTML = message
          document.querySelector('.newsletter-sign-up-before').classList.add('d-none')
          document.querySelector('.newsletter-sign-up-after').classList.remove('d-none')
        });
      }
    })
    .catch(error => console.log('error:', error));
};

export default {
  init() {
    // JavaScript to be fired on all pages
    document
      .getElementById('newsletter-js')
      .addEventListener('click', newsletterSubmit);

    serviceModal.init();

    require('../map/bundle.app')
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
